/**
 * @file Hook that tells us whether the compose form is minimized
 */
import { SEARCH_PARAM__COMPOSE } from '../../../constants/routing/searchParams';

import useSearchParams from './useSearchParams';

/**
 * Hook that tells us whether the compose form is minimized
 * based on the url
 *
 * @returns Whether compose form is minimized
 */
const useIsComposeMinimized = (): boolean => {
  const query = useSearchParams();

  const composeParam = query.get(SEARCH_PARAM__COMPOSE);

  return composeParam === 'minimized';
};

export default useIsComposeMinimized;
